import { CreateExternalRoleRequest, ExternalRoleResponse, ExternalRolesResponse, RolesClient, UpdateExternalRoleRequest } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const rolesClient = new RolesClient(undefined, axios);

export const useAccRoles = (options?: any) => {
  return useQuery<ExternalRolesResponse>({
    ...options,
    queryKey: ["accRoles"],
    initialData: { externalRoles: [] },
    queryFn: async () => rolesClient.getExternalRoles(),
  });
};

export const useAccRole = (externalRoleId: string, options?: any) => {
  return useQuery<ExternalRoleResponse>({
    ...options,
    queryKey: ["accRole", externalRoleId],
    enabled: !!externalRoleId && (options?.enabled !== false),
    queryFn: async () => rolesClient.getExternalRole(externalRoleId),
  });
};

export const useCreateAccRole = (options?: any) => {
  return useMutation<ExternalRoleResponse, unknown, CreateExternalRoleRequest>({
    ...options,
    mutationFn: (createExternalRoleRequest: CreateExternalRoleRequest) => rolesClient.createExternalRole(createExternalRoleRequest),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["accRoles"] });
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      options?.onError?.(error);
    },
  });
};

export const useUpdateAccRole = (options?: any) => {
  return useMutation<ExternalRoleResponse, unknown, UpdateExternalRoleRequest>({
    ...options,
    mutationFn: (updateExternalRoleRequest: UpdateExternalRoleRequest) =>
      rolesClient.updateExternalRole(updateExternalRoleRequest.externalRoleId!, updateExternalRoleRequest),
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({ queryKey: ["accRoles"] });
      await queryClient.invalidateQueries({ queryKey: ["accRole", variables.externalRoleId] });
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      options?.onError?.(error);
    },
  });
};

export const useDeleteAccRole = (options?: any) => {
  return useMutation<void, unknown, string>({
    ...options,
    mutationFn: (externalRoleId: string) => rolesClient.deleteExternalRole(externalRoleId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["accRoles"] });
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      options?.onError?.(error);
    },
  });
};

